import * as signalR from "@microsoft/signalr";
import { IJob } from "../types/IJob";

export class JobMonitoringService {

    private static connection: signalR.HubConnection | null = null;

    public static stopMonitoringProgress(): void {
        if (this.connection) {
            this.connection.off("messageReceived");
            this.connection.stop()
                .catch(err => console.error("Failed to stop SignalR:", err));
        }
    }

    public static startMonitoringProgress(callback: (jobs: IJob[]) => void): void {
        if (!this.connection) {
            this.connection = new signalR.HubConnectionBuilder()
                .withUrl("/job", { transport: signalR.HttpTransportType.ServerSentEvents })
                .withAutomaticReconnect()
                .build();
        }

        this.connection.on("messageReceived", callback);
        if (this.connection.state === signalR.HubConnectionState.Disconnected) {
            this.connection.start()
                .catch((err) => console.error("SignalR start failed:", err));
        }
    }
}